import React from "react";
import { NavLink, useLocation, matchPath } from "react-router-dom";
import "../nav/nav.css";
import { LOGO1 } from "../image";

const Nav = ({ onNavClick }) => {
  const location = useLocation();

  const displayNav = [
    "/",
    "/dashboard",
    "/users",
    "/stories",
    "/admins",
    "/view-user/:id",
    "/view-story/:id",
    "/view-admin/:id",
    "/privacy-policy",
    "/terms-conditions",
    "/character",
    "/site-settings",
    "/messages",
    "/questions",
    "/answers",
    "/view-answer/:id",
    "/instructions",
    "/video-statistics",
    "/view-video-statistics",
    "/special-features",
    "/view-instruction/:id",
    "/profile",
  ].some((path) => matchPath({ path, exact: true }, location.pathname));

  const isActive = (path) => {
    return matchPath({ path, exact: true }, location.pathname);
  };

  return (
    displayNav && (
      <nav>
        <NavLink to="/dashboard">
          <div className="logo">
            <img
              src={LOGO1}
              height={38}
              width={38}
              className="mt-3"
              alt="Logo"
            />
          </div>
        </NavLink>
        <div className="menu-items">
          <ul className="navLinks">
            <li className={`navList ${isActive("/dashboard") ? "active" : ""}`}>
              <NavLink
                to="/dashboard"
                className="navLink"
                activeClassName="active"
              >
                <ion-icon name="home-outline"></ion-icon>
                <span className="links">Dashboard</span>
              </NavLink>
            </li>
            <li
              className={`navList ${
                isActive("/video-statistics") ||
                isActive("/view-video-statistics")
                  ? "active"
                  : ""
              }`}
            >
              <NavLink
                to="/video-statistics"
                className="navLink"
                activeClassName="active"
              >
                <ion-icon name="stats-chart-outline"></ion-icon>
                <span className="links">Video statistics</span>
              </NavLink>
            </li>
            <li
              className={`navList ${
                isActive("/admins") || isActive("/view-admin/:id")
                  ? "active"
                  : ""
              }`}
            >
              <NavLink
                to="/admins"
                className="navLink"
                activeClassName="active"
              >
                <ion-icon name="people-outline"></ion-icon>
                <span className="links">Admins</span>
              </NavLink>
            </li>
            {/* <li
              className={`navList ${
                isActive("/users") || isActive("/view-user/:id") ? "active" : ""
              }`}
            >
              <NavLink to="/users" className="navLink" activeClassName="active">
                <ion-icon name="people-outline"></ion-icon>
                <span className="links">Users</span>
              </NavLink>
            </li> */}
            <li
              className={`navList ${
                isActive("/stories") || isActive("/view-story/:id")
                  ? "active"
                  : ""
              }`}
            >
              <NavLink
                to="/stories"
                className="navLink"
                activeClassName="active"
              >
                <ion-icon name="add-circle-outline"></ion-icon>
                <span className="links">Stories</span>
              </NavLink>
            </li>

            <li className={`navList ${isActive("/questions") ? "active" : ""}`}>
              <NavLink
                to="/questions"
                className="navLink"
                activeClassName="active"
              >
                <ion-icon name="help-circle-outline"></ion-icon>
                <span className="links">Questions</span>
              </NavLink>
            </li>
            <li
              className={`navList ${
                isActive("/answers") || isActive("/view-answer/:id")
                  ? "active"
                  : ""
              }`}
            >
              <NavLink
                to="/answers"
                className="navLink"
                activeClassName="active"
              >
                <ion-icon name="bag-check-outline"></ion-icon>
                <span className="links">Answers</span>
              </NavLink>
            </li>
            <li
              className={`navList ${
                isActive("/instructions") || isActive("/view-instruction/:id")
                  ? "active"
                  : ""
              }`}
            >
              <NavLink
                to="/instructions"
                className="navLink"
                activeClassName="active"
              >
                <ion-icon name="alert-circle-outline"></ion-icon>
                <span className="links">Instructions</span>
              </NavLink>
            </li>
            <li className={`navList ${isActive(`/messages`) ? "active" : ""}`}>
              <NavLink
                to={`/messages`}
                className="navLink"
                activeClassName="active"
              >
                <ion-icon name="mail-outline"></ion-icon>
                <span className="links">Messages</span>
              </NavLink>
            </li>
            <li
              className={`navList ${
                isActive("/special-features") ? "active" : ""
              }`}
            >
              <NavLink
                to="/special-features"
                className="navLink"
                activeClassName="active"
              >
                <ion-icon name="cloud-download-outline"></ion-icon>
                <span className="links">Special features</span>
              </NavLink>
            </li>
            <li
              className={`navList ${
                isActive("/site-settings") ? "active" : ""
              }`}
            >
              <NavLink
                to="/site-settings"
                className="navLink"
                activeClassName="active"
              >
                <ion-icon name="settings-outline"></ion-icon>
                <span className="links">Site settings</span>
              </NavLink>
            </li>
            <li
              className={`navList ${
                isActive("/terms-conditions") ? "active" : ""
              }`}
            >
              <NavLink
                to="/terms-conditions"
                className="navLink"
                activeClassName="active"
              >
                <ion-icon name="reader-outline"></ion-icon>
                <span className="links">Terms & Conditions</span>
              </NavLink>
            </li>
            <li
              className={`navList ${
                isActive("/privacy-policy") ? "active" : ""
              }`}
            >
              <NavLink
                to="/privacy-policy"
                className="navLink"
                activeClassName="active"
              >
                <ion-icon name="lock-closed-outline"></ion-icon>
                <span className="links">Privacy Policy</span>
              </NavLink>
            </li>

            {/* 
            <li className={`navList ${isActive("/character") ? "active" : ""}`}>
              <NavLink
                to="/character"
                className="navLink"
                activeClassName="active"
              >
                <ion-icon name="accessibility-outline"></ion-icon>
                <span className="links">Characters</span>
              </NavLink>
            </li> */}
          </ul>
          <ul className="bottom-link">
            <li className={`navList ${isActive("/profile") ? "active" : ""}`}>
              <NavLink
                to="/profile"
                className="navLink"
                activeClassName="active"
              >
                <ion-icon name="person-circle-outline"></ion-icon>
                <span className="links">Profile</span>
              </NavLink>
            </li>
            <li className={`navList ${isActive("/logout") ? "active" : ""}`}>
              <NavLink to="/login" className="navLink" activeClassName="active">
                <ion-icon name="log-out-outline"></ion-icon>
                <span className="links">Logout</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
    )
  );
};

export default Nav;
